import { defineMessages, useIntl } from 'react-intl';
import { switchcase } from '@sg/garnish';
import type { DeliveryPreferenceType } from '@sg/graphql-schema';

export const usePreferencesText = (type: DeliveryPreferenceType): string => {
  const { formatMessage } = useIntl();

  return switchcase({
    LEAVE_AT_DOOR: formatMessage(messages.deliveryPreferencesLeaveAtDoor),
    DOOR: formatMessage(messages.deliveryPreferencesMeetAtDoor),
    CURBSIDE: formatMessage(messages.deliveryPreferencesMeetOutside),
  })(formatMessage(messages.deliveryPreferencesLeaveAtDoor))(type);
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  deliveryPreferencesLeaveAtDoor: {
    defaultMessage: 'Leave at door',
    description: 'Delivery | Preferences | Leave At Door',
  },
  deliveryPreferencesMeetAtDoor: {
    defaultMessage: 'Meet at door',
    description: 'Delivery | Preferences | Meet At Door',
  },
  deliveryPreferencesMeetOutside: {
    defaultMessage: 'Meet outside',
    description: 'Delivery | Preferences | Meet Outside',
  },
});
